<template>
  <div>
    <b-modal
      ref="modalQuoteSubmitConfirm"
      hide-footer
      title="Quote pending application Submit"
    >
      <div class="d-block">
        <p class="fw-600">
          Pending Application :
          <span class="badge bg-amended">{{ quoteId }}</span>
        </p>

        <div class="row" v-if="Object.hasOwn(client, 'firstName')">
          <div class="col-12">
            <WDClient :clientInfo="client"></WDClient>
          </div>
        </div>

        <p class="text-danger">
          You have changed the quote values now or previously.
        </p>
        <p class="text-danger">
          If you have finished your update/s please click Submit button or else
          click Continue button ?
        </p>

        <div class="row">
          <div class="col-12 text-right">
            <button
              type="button"
              class="btn btn-primary mr-2"
              @click="fnUpdateStatusOnly(3)"
            >
              Submit
            </button>
            <button type="button" class="btn btn-dark" @click="fnModalHide">
              Continue update
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as quoteService from '../../services/quote.service'
import WDClient from '../../components/wd/WDClient.vue'

export default {
  name: 'ModalQuoteSubmitConfirm',
  props: ['propsData', 'quoteType'],
  components: {
    WDClient
  },
  data() {
    return {
      errors: {},
      quoteId: this.$route.params.quoteId,
      documentId: '',
      is_spinActive: false,
      privacyConsent: 0,

      // client_vehicle_details
      vehicle: {
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: '',
        salaryPackagingProviderFee: '',
        vehicleCondition: '',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: '',
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: '',
        fuelTypeId: '',
        colour: '',
        accessories: '',
        term: '',
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: '',
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: '',
        stampDuty: '',
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: '',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: '',
        dealerBrokerage: '',
        status: '',
        sortOrder: '',
        has_messages: '',
        messages_for_vsa: '',
        messages_for_other: '',
        privacyConsent: '',
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: '',
        dateOfBirth: '',
        anotherNameYesNo: '',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: '',
        maritalStatus: '',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: '',
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: '',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: '',
        hAddressTimeAtYears: '',
        hAddressTimeAtMonths: '',
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: '',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: '',
        postalAddressAndHomeAddressAreSameYesNo: '',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      }
    }
  },
  methods: {
    ...mapActions(['fetchQuoteSingle']),

    fnModalHide() {
      this.$refs['modalQuoteSubmitConfirm'].hide()
    },
    fnModalShow() {
      this.vehicle.clientId = this.propsData.clientId
      this.vehicle.dealerId = this.propsData.dealerId
      this.vehicle.referralPartnerId = this.propsData.referralPartnerId
      this.vehicle.referDealerId = this.propsData.referDealerId
      this.vehicle.leadSource = this.propsData.leadSource
      this.vehicle.salaryPackagingProviderId =
        this.propsData.salaryPackagingProviderId
      this.vehicle.salaryPackagingProviderFee =
        this.propsData.salaryPackagingProviderFee
      this.vehicle.vehicleCondition = this.propsData.vehicleCondition
      this.vehicle.odometerReading = this.propsData.odometerReading
      this.vehicle.year = this.propsData.year
      this.vehicle.make = this.propsData.make
      this.vehicle.model = this.propsData.model
      this.vehicle.variant = this.propsData.variant
      this.vehicle.bodyType = this.propsData.bodyType
      this.vehicle.vehicleCategoryId = this.propsData.vehicleCategoryId
      this.vehicle.fuelFlatRate = this.propsData.fuelFlatRate
      this.vehicle.fuelCostPerKM = this.propsData.fuelCostPerKM
      this.vehicle.tyresCostPerKM = this.propsData.tyresCostPerKM
      this.vehicle.serviceCostPerKM = this.propsData.serviceCostPerKM
      this.vehicle.transmissionId = this.propsData.transmissionId
      this.vehicle.fuelTypeId = this.propsData.fuelTypeId
      this.vehicle.colour = this.propsData.colour
      this.vehicle.accessories = this.propsData.accessories
      this.vehicle.term = this.propsData.term
      this.vehicle.rvRate = this.propsData.rvRate
      this.vehicle.annualKms = this.propsData.annualKms
      this.vehicle.noFinanceInsurance = this.propsData.noFinanceInsurance
      this.vehicle.comprehensiveInsurer = this.propsData.comprehensiveInsurer
      this.vehicle.comprehensiveInsurancePremium =
        this.propsData.comprehensiveInsurancePremium
      this.vehicle.businessUsePercentage = this.propsData.businessUsePercentage
      this.vehicle.stampDuty = this.propsData.stampDuty
      this.vehicle.registration = this.propsData.registration
      this.vehicle.gstOnAsset = this.propsData.gstOnAsset
      this.vehicle.gstOnAssetActual = this.propsData.gstOnAssetActual
      this.vehicle.totalDriveAwayCost = this.propsData.totalDriveAwayCost
      this.vehicle.chanageBudgetsYesNo = this.propsData.chanageBudgetsYesNo
      this.vehicle.fuelBudget = this.propsData.fuelBudget
      this.vehicle.serviceBudget = this.propsData.serviceBudget
      this.vehicle.tyreBudget = this.propsData.tyreBudget
      this.vehicle.needToCompeteYesNo = this.propsData.needToCompeteYesNo
      this.vehicle.dealerBrokerage = this.propsData.dealerBrokerage
      this.vehicle.status = this.propsData.status
      this.vehicle.sortOrder = this.propsData.sortOrder
      this.vehicle.has_messages = this.propsData.has_messages
      this.vehicle.messages_for_vsa = this.propsData.messages_for_vsa
      this.vehicle.messages_for_other = this.propsData.messages_for_other
      this.vehicle.privacyConsent = this.propsData.privacyConsent
      this.vehicle.settlementDate = this.propsData.settlementDate
      this.vehicle.fa_no = this.propsData.fa_no
      this.vehicle.edd = this.propsData.edd
      Object.assign(this.client, this.propsData.client)
      this.$refs['modalQuoteSubmitConfirm'].show()
    },

    /**
     * Update if quote status only
     */
    fnUpdateStatusOnly: async function (statusId) {
      await quoteService.updateQuoteStatusOnly(this.quoteId, {
        status: statusId
      })
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.fnModalHide()
    }
  }
}
</script>
